export const ACCEPT_PATH = ['/', '/guide', '/blog', '/listing', '/about-us', '/404', '/500'];
export const PROTECTED_PATH = ['/my', '/shortlist', '/order', '/reservation', '/carts', '/request-room/form'];

// 메타 광고 웰컴 랜딩 — 라우트 등록(AppContent)과 가입 완료 분기(SignupStep5)가 공용 참조
export const WELCOME_PATH = '/welcome';
